import script from "./AppCommonLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./AppCommonLayout.vue?vue&type=script&setup=true&lang=js"

export default script